import React, { Component, PropTypes } from 'react';
import reactUpdate from 'react-addons-update';
import { connect } from 'react-redux';
import EditFieldModal from './edit-field-modal';

class EditFieldModalContainer extends Component {

  checkIfValidAddress = (isValidAddress) => {
    const { sendEditToReducer } = this.props;
    if (isValidAddress !== this.props.editFieldModal.isValidAddress) sendEditToReducer({ isValidAddress });
  };

  _validateFieldForTextArea = (fieldToValidate, type) => {
    const required = this.props.editFieldModal.settings ? this.props.editFieldModal.settings.isRequired : false;
    if (fieldToValidate === undefined && required) return 'Required';
    if (fieldToValidate === '' && required) return 'Required';
    if (type === 'roomCountInfo' || type === 'number') {
      if (isNaN(fieldToValidate)) return 'Must Be A Valid Number';
      if (!(parseInt(fieldToValidate, 10) >= 0) || (String(parseInt(fieldToValidate, 10))).length !== String(fieldToValidate).length) return 'Must Be A Valid Number';
    }
    if (type === 'tourDuration') {
      if (parseFloat(fieldToValidate) === 0) return 'Number Must Be Greater Than Zero';
      if (isNaN(fieldToValidate)) return 'Must Be A Valid Number';
      if (!(parseFloat(fieldToValidate) >= 0) || (String(parseFloat(fieldToValidate, 10))).length !== String(fieldToValidate).length && parseFloat(fieldToValidate)) return 'Must Be A Valid Number';
    }
    if (type === 'roomSizeInfo') {
      // Ensures that only characters are digits/commas/periods - must be 0.12 or 0,12 (for european standard)
      if (!RegExp(/^[0-9]*?(\d(\.|\,)[0-9]+)*?$/).test(fieldToValidate)) return 'Must Be A Valid Number';
    }
  };

  _updateFieldValue = (event) => {
    this.props.sendEditToReducer({ value: event.target.value });
  };

  _locateAddress = addressRef => {
    addressRef.geoLocateAndConfirmAddress((hasFormattedAddress, geoLocatedAddress) => {
      this.props.sendEditToReducer({
        needsToConfirmAddress: true,
        hasFormattedAddress,
        addressToConfirm: geoLocatedAddress,
      });
    });
  };

  _dismissModal = () => {
    this.props.clearModalState();
  };

  _toggleOptionValue = options => {
    this.props.sendEditToReducer({
      value: options ? options.map(({ value }) => value) : [],
    });
  };

  _goBack = () => {
    this.props.sendEditToReducer({
      needsToConfirmAddress: false,
      hasTriedToLocate: true,
    });
  };

  checkIfValidContact = (isContactsInvalid) => {
    if (isContactsInvalid !== this.props.editFieldModal.isContactsInvalid) this.props.sendEditToReducer({ isContactsInvalid });
  };

  checkIfShouldBeDisabled = () => {
    const { editFieldModal } = this.props;
    const { settings, value } = editFieldModal;
    const required = settings ? settings.isRequired : false;
    if (value && required) {
      if (typeof value === 'string') return !value;
      if (Array.isArray(value)) return !value.some(item => item.value);
      if (typeof value === 'object') {
        return !Object.keys(value).every(key => {
          if (settings && settings.type === 'tourDuration') {
            if (key === 'value') return parseFloat(value[key]);
            return value[key];
          } else if (settings && settings.type === 'roomSizeInfo' && key === 'value') {
            return value[key] && RegExp(/^[0-9]*?(\d(\.|\,)[0-9]+)*?$/).test(value[key]);
          } else if (settings && settings.type === 'roomCountInfo' && key === 'value') {
            return !Boolean(this._validateFieldForTextArea(value.value, 'roomCountInfo'));
          }
          return value[key];
        });
      }
    }
    return required;
  };

  _updateSubField = (subField, updateValue) => {
    const { sendEditToReducer } = this.props;
    if (typeof this.props.editFieldModal.value !== 'object') return;
    const valueToSet = reactUpdate(this.props.editFieldModal.value, {
      $apply: value => {
        if (typeof value === 'object') {
          value[subField] = updateValue;
          return (value);
        }
        return value;
      },
    });
    sendEditToReducer({ value: valueToSet });
  };


  render() {
    const props = {
      checkIfValidAddress: this.checkIfValidAddress,
      _validateFieldForTextArea: this._validateFieldForTextArea,
      _updateFieldValue: this._updateFieldValue,
      _locateAddress: this._locateAddress,
      _dismissModal: this._dismissModal,
      _toggleOptionValue: this._toggleOptionValue,
      _goBack: this._goBack,
      checkIfValidContact: this.checkIfValidContact,
      checkIfShouldBeDisabled: this.checkIfShouldBeDisabled,
      _updateSubField: this._updateSubField,
      ...this.props,
    };
    return <EditFieldModal {...props} />;
  }
}

const select = state => ({ editFieldModal: state.editFieldModal.toJS() });

EditFieldModalContainer.propTypes = {
  dispatch: PropTypes.func,
  sendEditToReducer: PropTypes.func,
  isValidAddress: PropTypes.bool,
  dialogOpen: PropTypes.bool,
  editFieldModal: PropTypes.object,
  clearModalState: PropTypes.func,
};

export default connect(select)(EditFieldModalContainer);



// WEBPACK FOOTER //
// ./src/app/components/profile/edit-modal/edit-field-modal-container.jsx